import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/pro-regular-svg-icons';
import HiddenSensorsModal from './HiddenSensorsModal';

// eslint-disable-next-line import/prefer-default-export
export const ShowHiddenSensorsButton = ({ hiddenChannelGroups, isAdapterHidden = false }) => {
  const [showModal, setShowModal] = useState(false);

  if (!hiddenChannelGroups.length) return null;

  return (
    <div className="my-2">
      <Button
        variant="link"
        className="text-primary p-0"
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faEye} className="mr-1" />
        Show hidden
        {isAdapterHidden ? ' adapter' : ' sensors'}
      </Button>

      <HiddenSensorsModal
        show={showModal}
        handleClose={() => setShowModal(false)}
        hiddenChannelGroups={hiddenChannelGroups}
      />
    </div>
  );
};

ShowHiddenSensorsButton.defaultProps = {
  isAdapterHidden: false,
};
ShowHiddenSensorsButton.propTypes = {
  hiddenChannelGroups: PropTypes.arrayOf(PropTypes.string).isRequired,
  isAdapterHidden: PropTypes.bool,
};
